import { getTimeZones } from '@vvo/tzdb'

const timezones = getTimeZones()

export default timezones
